import { makeObservable, observable } from 'mobx'

import { DTO } from '../DTO'

// 학생이름 관련 제외한 나머지 옵션
export class PrintOption extends DTO {
  machineId = '' // PC ID
  printer = '' // 프린터 명
  isMonochrome = false // 흑백 여부
  isBooklet = false // 모아찍기 여부
  isDuplex = true // 양면인쇄 여부
  isReverse = false // 역순 여부
  excludeCoverPage = false // 내지 제거 여부
  paperType = 'A4' // 종이타입 (A4, A3, B4, B3)
  copyNumber = 1 // 출력 부수

  constructor(data?: Partial<PrintOption>) {
    super()
    if (data) {
      Object.assign(this, data)
    }

    makeObservable(this, {
      machineId: observable,
      printer: observable,
      isMonochrome: observable,
      isBooklet: observable,
      isDuplex: observable,
      isReverse: observable,
      excludeCoverPage: observable,
      paperType: observable,
      copyNumber: observable,
    })
  }

  get params(): Omit<req.CommonPrintOption, 'page' | 'teacherId'> {
    return {
      machineId: this.machineId,
      printer: this.printer,
      isMonochrome: this.isMonochrome,
      isBooklet: this.isBooklet,
      isDuplex: this.isDuplex,
      isReverse: this.isReverse,
      paperType: this.paperType,
      copyNumber: this.copyNumber,
    }
  }
}
